<template>
    <q-page padding class="column items-center q-gutter-xs">
        <div class="col full-width">
            <update-project-form />
        </div>
        <div class="col full-width">
            <update-project-labels />
        </div>
        <div class="col full-width">
            <update-project-properties />
        </div>
        <div class="col full-width">
            <update-project-photo-caption />
        </div>
    </q-page>
</template>

<script setup lang="ts">
import UpdateProjectForm from "../components/UpdateProjectForm.vue";
import UpdateProjectLabels from "../components/UpdateProjectLabels.vue";
import UpdateProjectPhotoCaption from "../components/UpdateProjectPhotoCaption.vue";
import UpdateProjectProperties from "../components/UpdateProjectProperties.vue";
import { useProjectStore } from "../store/project";
import { storeToRefs } from "pinia";
import { useUserStore } from "../store/user";

const store = useProjectStore()
const userStore = useUserStore()

const { project, loading } = storeToRefs(store)
const { user } = storeToRefs(userStore)
</script>

<style scoped></style>